export const radii = {
  none: "0",
  "2xs": "1px",
  xs: "2px",
  sm: "4px",
  md: "6px",
  lg: "8px",
  xl: "12px",
  "2xl": "16px",
  "3xl": "24px",
  "4xl": "32px",
  full: "9999px",
};
